<div class="tab-panel tab-panel--comments">
  <section>
    <div>
      @if (selectedWorkspace && selectedWorkspaceInstanceNode) {
      <app-comment></app-comment>
      }
    </div>
  </section>
</div>
